
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function UploadCTA() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-r from-purple-600 to-pink-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <i className="ri-upload-cloud-2-line text-6xl text-white mb-6 block"></i>
          <h2 className="text-4xl font-bold text-white mb-4">
            Share Your Music with the World
          </h2>
          <p className="text-xl text-purple-100 mb-8 max-w-2xl mx-auto">
            Upload your tracks, build your fanbase, and connect with millions of listeners. 
            Join thousands of artists who've made SoundWave their home.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button 
            variant="secondary" 
            size="lg"
            className="bg-white text-purple-600 hover:bg-gray-100"
            onClick={() => navigate('/upload')}
          >
            <i className="ri-upload-2-line mr-2 text-xl"></i>
            Upload Your First Track
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            className="border-white text-white hover:bg-white hover:text-purple-600"
            onClick={() => navigate('/upload')}
          >
            <i className="ri-information-line mr-2 text-xl"></i>
            Learn More
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
          <div>
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-music-2-line text-xl"></i>
            </div>
            <h3 className="font-semibold mb-2">High Quality Audio</h3>
            <p className="text-purple-100 text-sm">Upload lossless audio files up to 1GB</p>
          </div>
          <div>
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-bar-chart-line text-xl"></i>
            </div>
            <h3 className="font-semibold mb-2">Detailed Analytics</h3>
            <p className="text-purple-100 text-sm">Track your plays, likes, and audience insights</p>
          </div>
          <div>
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-xl"></i>
            </div>
            <h3 className="font-semibold mb-2">Monetization</h3>
            <p className="text-purple-100 text-sm">Earn revenue from your music streams</p>
          </div>
        </div>
      </div>
    </section>
  );
}
